<app-modal-basic #modalPicker id="donorModalPicker">
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">{{pickingJointDonor ? 'Change joint donor' : 'Change donor'}}</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr [hidden]="!callbackRemoveJointDonor">
        <td colspan="5" style="padding-bottom: 15px">
          <a href="javascript:void(0);" (click)="removeJointDonor()">Remove joint donor</a>
        </td>
      </tr>
      <tr>
        <td>Name&nbsp;</td>
        <td style="padding-right: 10px">
          <input id="nameInput" type="text" [(ngModel)]="gridFilter.name" maxlength="45" (keydown.enter)="updateDonorsGrid()" class="form-control" trimOnBlur>
        </td>
        <td [hidden]="!enableDonorEnvelope">Envelope&nbsp;</td>
        <td [hidden]="!enableDonorEnvelope" style="padding-right: 10px">
          <input type="text" [(ngModel)]="gridFilter.envelope" maxlength="45" (keydown.enter)="updateDonorsGrid()" class="form-control" trimOnBlur>
        </td>
        <td>
          <button (click)="updateDonorsGrid()">Apply</button>
        </td>
      </tr>
      <tr>
        <td colspan="5" style="padding-top: 15px">
          <ag-grid-angular style="width: 100%; height: 270px;"
                           class="ag-theme-fresh"
                           id="gridDonors"
                           [paginationPageSize]="500"
                           [gridOptions]="gridOptions">
          </ag-grid-angular>
        </td>
      </tr>
      <tr [hidden]="!callbackAddDonor">
        <td colspan="5" style="padding-top: 15px">
          <a href="javascript:void(0);" (click)="addNewDonor()">Can't find donor? Click here to create a new donor.</a>
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-default btn-modal" (click)="cancelChangeDonor()">Cancel</button>
  </div>
</app-modal-basic>
